module.exports = __webpack_public_path__ + "img/BannerDailyMath.3410a339.png";